import { useRef, useEffect } from 'react'

export const usePrevious = <T extends any>(value: T): T => {
    const previous = useRef<T>(value)
    useEffect(() => {
        previous.current = value
    }, [JSON.stringify(value)])
    return previous.current
}
